import { api } from './api';

export interface EncuestaPublica {
  id: string;
  estado: string;
  puntuacion: number | null;
  ticket_numero: number | null;
  cliente_nombre: string | null;
  ya_respondida: boolean;
  expirada: boolean;
}

export interface ResponderEncuesta {
  puntuacion: number;
  comentario?: string;
}

export interface CSATStats {
  total_enviadas: number;
  total_respondidas: number;
  tasa_respuesta: number;
  puntuacion_promedio: number | null;
  nps_score: number | null;
  distribucion: Record<string, number>;
}

export const csatService = {
  async obtenerPorToken(token: string): Promise<EncuestaPublica> {
    return api.get<EncuestaPublica>(`/csat/encuesta/${token}`, false);
  },

  async responder(token: string, datos: ResponderEncuesta): Promise<EncuestaPublica> {
    return api.post<EncuestaPublica>(`/csat/encuesta/${token}/responder`, datos, false);
  },

  async obtenerStats(params?: { cliente_id?: string; agente_id?: string }): Promise<CSATStats> {
    const queryStr = params
      ? '?' + new URLSearchParams(
          Object.entries(params).filter(([, v]) => v !== undefined) as [string, string][]
        ).toString()
      : '';
    return api.get<CSATStats>(`/csat/stats${queryStr}`);
  },
};
